import React from 'react';

export default function Home() {
  return (
    <div className="home-page">
      <header className="header header-home">
        <h1>来往</h1>
        <p>人情往来记录 · 家庭组共享</p>
      </header>

      <main className="home-main">
        <div className="hero">
          <p className="hero-lead">记录每一份<span className="highlight">人情往来</span></p>
          <p className="hero-desc">一款专注于随礼、送礼记录的智能工具，帮助您轻松管理亲友间的人情往来</p>
          <div className="download-tip">请在手机应用商店搜索「来往」下载</div>
        </div>

        <div className="features">
          <div className="feature-item">
            <div className="feature-icon">📝</div>
            <div className="feature-title">便捷记录</div>
            <div className="feature-desc">快速记录每一笔人情往来</div>
          </div>
          <div className="feature-item">
            <div className="feature-icon">👨‍👩‍👧‍👦</div>
            <div className="feature-title">家庭共享</div>
            <div className="feature-desc">支持家庭组多人协作</div>
          </div>
          <div className="feature-item">
            <div className="feature-icon">📊</div>
            <div className="feature-title">智能统计</div>
            <div className="feature-desc">自动计算收支差额</div>
          </div>
        </div>
      </main>
    </div>
  );
}